(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-lp"]) return;
  try {
    
    console.log('template-lp');

  } catch(e) { console.error(e); }
})();
})();
